import { CSSProperties, ReactNode } from 'react';

import { Colors } from '@sternum/web/components/theme/constants';
import { useThemedValue } from '@sternum/web/hooks/useThemedValue';

import {
  LabelWrapperForHorizontal,
  LabelWrapperForVertical,
  SeparatorHorizontal,
  SeparatorVertical,
  Wrapper,
  WrapperForVertical,
} from './Separator.styles';

type ColorKey = keyof typeof Colors;

interface Color {
  Dark: ColorKey;
  Light: ColorKey;
}

type SeparatorProps = SeparatorHorizontal | SeparatorVertical;

type SeparatorDefaultProps = {
  color?: Color;
  h?: number | string;
  w?: number | string;
  label?: ReactNode;
  labelBg?: Color;
};

type SeparatorHorizontal = SeparatorDefaultProps & {
  type?: 'horizontal';
};

type SeparatorVertical = SeparatorDefaultProps & {
  type?: 'vertical';
  h: number | string;
};

const defaultLineColors = { Dark: Colors.GreyLightest, Light: Colors.GreyLightest };
const defaultLabelBgColors = { Dark: Colors.White, Light: Colors.White };

export function Separator({ type = 'horizontal', color, w, h, label, labelBg }: SeparatorProps) {
  const lineColors = color ? { Dark: Colors[color.Dark], Light: Colors[color.Light] } : defaultLineColors;
  const labelBgColors = labelBg ? { Dark: Colors[labelBg.Dark], Light: Colors[labelBg.Light] } : defaultLabelBgColors;

  const currentLineColor = useThemedValue(lineColors) as ColorKey;
  const currentLabelBgColor = useThemedValue(labelBgColors) as ColorKey;

  const separatorStyles: CSSProperties = {
    width: w,
    height: h,
    background: currentLineColor,
  };

  const labelStyles: CSSProperties = {
    background: currentLabelBgColor,
  };

  if (type === 'horizontal') {
    return (
      <Wrapper>
        {label && <LabelWrapperForHorizontal style={labelStyles}>{label}</LabelWrapperForHorizontal>}
        <SeparatorHorizontal style={separatorStyles} />
      </Wrapper>
    );
  }

  return (
    <WrapperForVertical>
      {label && <LabelWrapperForVertical style={labelStyles}>{label}</LabelWrapperForVertical>}
      <SeparatorVertical style={separatorStyles} />
    </WrapperForVertical>
  );
}
